import { render, staticRenderFns } from "./DiamondReport1024.vue?vue&type=template&id=894a3aee&scoped=true"
import script from "./DiamondReport1024.vue?vue&type=script&lang=js"
export * from "./DiamondReport1024.vue?vue&type=script&lang=js"
import style0 from "./DiamondReport1024.vue?vue&type=style&index=0&id=894a3aee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894a3aee",
  null
  
)

export default component.exports